import { toUnicode } from 'punycode';
import { component } from 'picoapp';

export default component((node) => {
  window.pcdecode = toUnicode;
  const validate = () => {
    const { value } = node;
    const unicodeValue = toUnicode(value);
    const errorCharacter = [';', 'Æ', 'æ', 'Ø', 'ø', 'Å', 'å'].find((char) =>
      unicodeValue.includes(char),
    );

    if (errorCharacter) {
      node.setCustomValidity(
        `${theme.strings.validation.emailCharacterError.replace(
          'NAME',
          'Email',
        )} "${errorCharacter}"`,
      );
      node.reportValidity();
    } else {
      node.setCustomValidity('');
    }
  };

  node.addEventListener('input', validate);
  node.addEventListener('change', validate);
  node.addEventListener('paste', validate);
  node.addEventListener('focusout', validate);
});
